module.exports = __webpack_public_path__ + "img/zoom.9448b6f6.png";